import { render, staticRenderFns } from "./UIPost.vue?vue&type=template&id=341740d6"
import script from "./UIPost.vue?vue&type=script&lang=js"
export * from "./UIPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports